import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register Service Worker for PWA / offline support.
// Only enable in production-like environments to avoid getting cached
// stale dev bundles during local development.
if ("serviceWorker" in navigator) {
  const enableSw =
    typeof window !== "undefined" &&
    window.location &&
    !["localhost", "127.0.0.1"].includes(window.location.hostname);
  if (enableSw) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.warn("SW registration failed:", err);
        });
    });
  }
}
